// extracted by mini-css-extract-plugin
export default {"rating":"OL-z","numberOfStars":"PL-z","count":"QL-z","barGraphSpacing":"RL-z","barGraph":"SL-z"};